import { useRequiredContext } from "@redotech/react-util/context";
import { useRpcData } from "@redotech/react-util/rpc-data";
import { readReturnsCenterId } from "@redotech/redo-return-core-common/returns-center-id";
import { RedoAdminRpcClientContext } from "../../../app/redo-admin-rpc-client-provider";

export interface ReturnsCenterRow {
  id: string;
  name: string;
  location?: string;
}

export function useReturnsCenterRows(
  teamCenters: readonly { returnsCenterId: string }[],
): ReturnsCenterRow[] {
  const rpcClient = useRequiredContext(RedoAdminRpcClientContext);
  const { value: data } = useRpcData(rpcClient, "getReturnsCenters", {
    input: { sort: null },
  });
  const byId = new Map(
    (data?.returnsCenters ?? []).flatMap((center) => {
      const id = readReturnsCenterId(center.id);
      return id === null ? [] : [[id, center] as const];
    }),
  );
  return teamCenters.flatMap(({ returnsCenterId }) => {
    const id = readReturnsCenterId(returnsCenterId);
    if (id === null) {
      return [];
    }
    const found = byId.get(id);
    return [
      {
        id: id.toString(),
        name: found?.name ?? id.toString(),
        location:
          [found?.city, found?.state].filter(Boolean).join(", ") || undefined,
      },
    ];
  });
}
